import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getOrgFeatureCategories = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/admin/features/org_categories`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
